import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Login from '../Login'

import * as authActions from '../../ducks/authentication'

function mapStateToProps(state) {
  return {
    hasLoginFailed: state.authentication.get('hasLoginFailed')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onLogin: bindActionCreators(authActions, dispatch).login
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/components/smart/LoginContainer.js